import React from 'react';
import Header from '../../../components/Header';
import Activities from '../../../components/Activities/Activity';
import TempOperatingInstructionDetailsPage from './TempOperatinInstructionDetailPage';
import { useParams } from 'react-router-dom';

const TempOperatingInstructionDetails = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Temporary Operating Instruction Details'} showBackButton={true} />

      <div className="grid grid-cols-12">
        {/* Main content */}
        <div className="col-span-8 px-6 py-6">
          <TempOperatingInstructionDetailsPage />
        </div>

        {/* Vertical Divider */}
        <div className="col-span-1 flex justify-end">
          <div className="w-px bg-gray-200 h-full translate-x-4" />
        </div>

        {/* Activities Sidebar */}
        <div className="md:col-span-1">
          <Activities moduleName="temporary_operating_instructions" moduleItemId={Number(id)} />
        </div>
      </div>
    </div>
  );
};

export default TempOperatingInstructionDetails;
